import { TranslatePipe } from '../../shared/translate/pipes/translate.pipe';
import { GoalView } from '../models/goal.model';
import { IReference, IGoal, IAuditEvent_Detail } from '@ahryman40k/ts-fhir-types/lib/R4';

function translateUnit(unit: string, translatePipe: TranslatePipe): string {
    return translatePipe.transform(unit.toUpperCase()) === unit.toUpperCase() ?
        unit : translatePipe.transform(unit.toUpperCase());
}

export function stringToGoalView(inData: IReference[], translatePipe: TranslatePipe): GoalView[] {
    const goalViews: GoalView[] = [];

    if (inData && inData[0]) {
        inData.map(data => {
            const split = data.display.split(';');
            goalViews.push({
                values: [
                    translatePipe.transform(split[0].toUpperCase()), split[1] + ' ' + translateUnit(split[2], translatePipe)
                ],
                reference: data.reference
            });
        });
    }
    return goalViews;
}

export function dataToGoalAuditEventDetail(oldData: IGoal, newData: IGoal): IAuditEvent_Detail[] {
    return [{
        type: 'old',
        valueString: oldData ?
            'goal;' + oldData.target[0].measure.text + ';' +
            oldData.target[0].detailQuantity.value + ';' + oldData.target[0].detailQuantity.unit : ''
    }, {
        type: 'new',
        valueString: 'goal;' + newData.target[0].measure.text + ';' +
            newData.target[0].detailQuantity.value + ';' + newData.target[0].detailQuantity.unit
    }];
}
